<div>
  <div class="w-full">
    <div class="flex flex-col justify-between pt-14">
      <div class="w-full age-wrap flex flex-row flex-wrap">
        <a class="w-full flex cursor-pointer beyond-port-banner" href="https://makemypass.com/event/beyond-port-80" target="_blank">
          <img class="w-full" src="assets/images/beyond/beyond-port-80-banner.jpg">
          <span class="reg-button"><img src="assets/images/beyond/reg-button.png"></span>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="w-full py-16 bg-[#EBECED]">
  <div class="container mx-auto">
    <div class="flex flex-col items-center justify-between">
      <div class="w-full md:w-[60%] lg:w-[57%] flex flex-col items-center justify-between px-5 md-px-0">
      <p class="font-semibold mb-3 text-2xl sm:text-xl xl:text-3xl w-full text-center">Beyond Borders. Beyond Syllabus. Beyond Gatekeepers.</p>
      <p class="text-base text-center">Having completed 12 years more than 200 sessions FAYA:80 is the longest-running tech
        community series, igniting minds, connecting innovators, and building bridges across
       <strong> Now, we go beyond</strong>.</p>
      </div>
    </div>
  </div>
</div>

<div class="w-full p-12 bg-[#fff]">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">SPEAKERS </span></h2>
    <div class="w-full mb-4 justify-center flex pb-8">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100 w-[300px] md:w-[350px] lg:w-[410px]">
        <a onclick="my_modal_01.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/ajith.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Ajit Balakrishnan</h2>
              <p class="text-neutral-400">Founder</p>
              <p class="text-neutral-600">rediff.com </p>
            </div>
            <p>Shri Ajit Balakrishnan, an alumnus of IIM Calcutta, is a pioneering Indian IT entrepreneur.</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_03.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/pradeep-nair.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Pradeep Nair</h2>
              <p class="text-neutral-400">Founder CTO, Armada</p>
              <p class="text-neutral-600">Dr Santosh Babu, IAS Principal Secretary & Managing Director, KSITIL </p>
            </div>
            <p>Pradeep Nair is the Founding CTO of Armada, a pioneering full-stack edge computing platform...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_02.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/thumb/jayasankar-prasad.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Dr Jayasankar Prasad</h2>
              <p class="text-neutral-400">Director, DCSMAT</p>
              <p class="text-neutral-600">Thought Works </p>
            </div>
            <p>Dr. Jayasankar Prasad C (Dr Jay) is a management professional with extensive experience in organizat......</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_04.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/jyothis.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Jyothis Indirabhai</h2>
              <p class="text-neutral-400">Co-Founder and CEO, Netrasemi</p>
            </div>
            <p>With over 25 years experience in microchip design, Jyothis Indirabhai is the Co-Founder and CEO of Netrasemi...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_05.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/pradeep-ps.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Pradeep P. S </h2>
              <p class="text-neutral-400">Founder, Farmers Fresh Zone</p>
            </div>
            <p>Pradeep P. S. is the visionary sole founder of Farmers Fresh Zone where he revolutionized the farm-to-consumer model...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_11.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/sivasankar.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
              <p class="text-neutral-400">IT Secretary</p>
              <p class="text-neutral-600">Government of Kerala </p>
            </div>
            <p>Shri. M Sivasankar is presently the Secretary to Government, IT Department..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_06.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/thumb/sunny.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Sunny Gupta</h2>
              <p class="text-neutral-400">Engineering Leader, Atlassian</p>
            </div>
            <p>Sunny Gupta is an accomplished Engineering Manager with Atlassian, one of the leading software companies...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_07.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/kailash.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Kailash Nadh</h2>
              <p class="text-neutral-400">CTO, Zerodha </p>
            </div>
            <p>Kailash Nadh is the CTO of Zerodha, India's largest stockbroker, where he built and leads the tech team pioneering innovative financial technology...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_08.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/santosh-babu.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Dr Santosh Babu, IAS</h2>
              <p class="text-neutral-400">Principal Secretary & Managing Director, KSITIL</p>
            </div>
            <p>Santhosh Babu is a Medical Doctor turned Indian Administrative Service (IAS) Officer of the 1995 batch, of the Tamil Nadu cadre....</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_09.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/suresh.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Dr. Suresh K</h2>
              <p class="text-neutral-400">Principal,College of Engineering Trivandrum</p>
            </div>
            <p>Dr.Suresh K is the Principal of the College of Engineering Trivandrum, bringing over two decades of experience in engineering education and academic leadership...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_010.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/suresh.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Rajasree M.S </h2>
              <p class="text-neutral-400">Chief Executive Officer, TrEST Research Park</p>
            </div>
            <p>Dr Rajasree is Professor in Computer Science and Engineering and has ser-ved in government engineering colleges...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_010.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/rajashree.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Rajasree M.S </h2>
              <p class="text-neutral-400">Chief Executive Officer, TrEST Research Park</p>
            </div>
            <p>Dr Rajasree is Professor in Computer Science and Engineering and has ser-ved in government engineering colleges...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_011.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/thumb/Rajeev-J-Sebastian.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Rajeev J Sebastian</h2>
              <p class="text-neutral-400">CEO, Alokin Software</p>
            </div>
            <p>Rajeev has associated with many successful national and international projects during his 16 years i...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_012.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/vimal-govind.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Vimal Govind M K</h2>
              <p class="text-neutral-400">Co-founder and Director, Genrobotic Innovations</p>
            </div>
            <p>Vimal Govind M. K is a notable robotic engineer and product architect from Kerala. As the Co-Founder and Managing Director...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_013.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/levin.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">G LEVIN</h2>
              <p class="text-neutral-400">Chief Executive Officer - Kerala Spacepark</p>
            </div>
            <p>38 years of illustrious career with Vikram Sarabhai Space Centre(VSSC), Indian Space Research Organization(ISRO)...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>




     
     
    </div>
  </div>
</div>
<!-- <div class="w-full p-12 g-slate-100">
  <div class="container mx-auto">
    <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-3xl pb-4 border-b">PANELLISTS </span></h2>
    <div class="grid  gap-4 md:gap-4 lg:gap-8 grid-cols-2 md:grid-cols-4 lg:grid-cols-5">
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_11.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/sivasankar.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
              <p class="text-neutral-400">IT Secretary</p>
              <p class="text-neutral-600">Government of Kerala </p>
            </div>
            <p>Shri. M Sivasankar is presently the Secretary to Government, IT Department..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_2.showModal()">
          <figure class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/beyond/speaker/ajith.jpg" alt="" />
          </figure>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr. Michael Gord</h2>
              <p class="text-neutral-400">Founder & CEO</p>
              <p class="text-neutral-600">MLG Blockchain Consulting </p>
            </div>
            <p>Michael is a blockchain developer at TD and the founder of Bitcoin Canada and the McGill Cryptocurrency
              Club</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_4.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/nandini.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Professor Nandini Vaidyanathan</h2>
              <p class="text-neutral-400">Chairman and Managing Director</p>
              <p class="text-neutral-600">CARMa Venture Services </p>
            </div>
            <p>She’s a traveling teacher who specialises in entrepreneurship, in several...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_13.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/ashraf.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Dr. Asharaf S</h2>
              <p class="text-neutral-400">Associate Professor</p>
              <p class="text-neutral-600">IIITMK </p>
            </div>
            <p>Asharaf S is an Associate Professor at Indian Institute of
              Information Technology...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_14.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/rahul.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr Rahul Alex Panicker</h2>
              <p class="text-neutral-400">Co-founder and President</p>
              <p class="text-neutral-600">Embrace Innovations </p>
            </div>
            <p>Asharaf S is an Associate Professor at Indian Institute of
              Information Technology...</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_15.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/aswin.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Mr Aswin P</h2>
              <p class="text-neutral-400">Program Manager</p>
              <p class="text-neutral-600">Frost Sullivan's Middle East</p>
            </div>
            <p>Aswin Kumar is Program Manager with the Mobility (Automotive & Transportation) Practice..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
      <div class="card cursor-pointer group card-compact shadow-lg bg-base-100">
        <a onclick="my_modal_16.showModal()">
          <div class="max-h-72">
            <img class="w-full grayscale group-hover:grayscale-0 ease-linear duration-100"
              src="assets/images/dk17/anoop.jpg" alt="" />
          </div>
          <div class="card-body">
            <div class="text-center">
              <h2 class="text-xl font-bold mb-0">Anoop Ambika</h2>
              <p class="text-neutral-400">Founder</p>
              <p class="text-neutral-600">CLAP Research</p>
            </div>
            <p>Anoop P Ambika is a serial entrepreneur, organiser and a
              technology enthusiast. He is the co-founder..</p>
            <div class="card-actions justify-start">
              <span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read
                More</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div> -->
<div class="w-full p-12 bg-slate-50">
  <div class="container mx-auto">
    <div class="mb-4">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-2xl sm:text-xl xl:text-3xl pb-4 border-b">Inauguration Ceremony Travancore Hall</span></h2>
      <div class="flex flex-wrap">
        <div class="w-full md:w-[50%] lg:w-[33%]">
          <img src="assets/images/beyond/beyond-img.jpg">
        </div>
        <div class="w-full md:w-[50%] lg:w-[67%]">
          <ul class="md:mt-0 mt-5 ml-0 md:ml-4">
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">9:30AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Guest Arrival & Registration</p>
                <p>Community wall signing, networking photo booth, light music</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">10:00AM - 10:05AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold mb-3">Welcome Note</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">10:05AM - 10:10AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Visual Kickoff</p>
                <p>Recap of 12 Years of FAYA:80 – The Karma Economy in Action</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">10:10AM - 10:15AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Setting the Context</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">10:15AM - 10:30AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Keynote by Ajit Balakrishnan, Founder of rediff.com</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-3">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">10:30AM - 10:50AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Keynote by Pradeep Nair, Founder CTO, Armada</p>
              </div>
            </li>
            <li class="flex flex-wrap marker">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">10:50AM - 11:15AM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold ">Story of HR Evolve</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full py-10 bg-[#f4f4f4]">
  <div class="container mx-auto">
    <div class="flex flex-col items-center justify-between">
      <div class="w-full md:w-[60%] lg:w-[57%] flex flex-col items-center justify-between px-5 md-px-0">
      <p class="font-semibold mb-3 text-xl sm:text-[26px] w-full text-center">Tea Break & Networking</p>
      <p class="text-base text-center">11:15AM - 11:30AM</p>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-12 flex flex-col sm:flex-row mb-5 justify-between">
  <div class="w-full sm:w-[49%]">
    <h2 class="pb-4 flex font-bold text-gray-600 text-2xl sm:text-xl xl:text-3xl mb-5 border-b">Round Table: Beyond Borders</h2>
    <div class="flex flex-wrap flex-col lg:flex-row">
      <div class="w-full lg:w-[40%] xl:w-[50%]">
        <img class="w-full" src="assets/images/beyond/boarders.jpg">
      </div>
      <div class="w-full lg:w-[60%] xl:w-[50%]">
        <ul class="pl-0 lg:pl-5 lg:pt-0 pt-5">
          <li class="flex flex-wrap marker pb-3">
            <div class="w-full text-gray-500 text-sm">11:30AM - 11:40PM</div>
            <div class="w-full text-gray-500 text-sm">
              <p class="font-bold">Technology Beyond Syllabus </p>
            </div>
          </li>
          <li class="flex flex-wrap marker pb-3">
            <div class="w-full text-gray-500 text-sm">11:40AM - 01:00PM</div>
            <div class="w-full text-gray-500 text-sm">
              <p class="font-bold">Recognition of Ecosystem Enablers</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="w-full sm:w-[49%]">
    <h2 class="pb-4 flex font-bold text-gray-600 text-2xl sm:text-xl xl:text-3xl mb-5 border-b">Unconference: Beyond Syllabus</h2>
    <div class="flex flex-wrap flex-col lg:flex-row">
      <div class="w-full lg:w-[40%] xl:w-[50%]">
        <img class="w-full" src="assets/images/beyond/Syllabus.jpg">
      </div>
      <div class="w-full lg:w-[60%] xl:w-[50%]">
        <ul class="pl-0 lg:pl-5 lg:pt-0 pt-5">
          <li class="flex flex-wrap marker pb-3">
            <div class="w-full text-gray-500 text-sm">11:30AM - 01:00PM</div>
            <div class="w-full text-gray-500 text-sm">
              <p class="font-bold">Unconference: Creativity Beyond Syllabus</p>
              <!-- <p>Venue: FAYA</p> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="w-full py-10 bg-[#f4f4f4]">
  <div class="container mx-auto">
    <div class="flex flex-col items-center justify-between">
      <div class="w-full md:w-[60%] lg:w-[57%] flex flex-col items-center justify-between px-5 md-px-0">
      <p class="font-semibold mb-3 text-xl sm:text-[26px] w-full text-center">Lunch Break & Networking</p>
      <p class="text-base text-center">01:00PM - 02:00PM</p>
      </div>
    </div>
  </div>
</div>
<div class="w-full p-12 bg-slate-50">
  <div class="container mx-auto">
    <div class="mb-4">
      <h2 class="pb-4 flex"> <span class="font-bold text-gray-600 text-2xl sm:text-xl xl:text-3xl pb-4 border-b mb-2">The Purple Waves - Beyond Gatekeepers</span></h2>
      <div class="flex flex-wrap">
        <div class="w-full md:w-1/2 lg:w-1/4">
          <img src="assets/images/beyond/Gatekeepers.jpg">
        </div>
        <div class="w-full md:w-1/2 lg:w-3/4">
          <ul class="md:mt-0 mt-5 ml-0 md:ml-4">
            <li class="flex flex-wrap marker">
              <div class="w-full lg:w-1/4 text-gray-500 text-sm"></div>
              <div class="w-full lg:w-3/4 text-gray-500 text-sm">
                <p class="font-bold"></p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-4">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">02:00PM - 02:30PM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Roundtable Recap & Moderator shares key insights</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-4">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">02:30PM – 03:00PM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">Reveal of Beyond Gatekeepers</p>
                <p>Community Recognition Ceremony</p>
              </div>
            </li>
            <li class="flex flex-wrap marker pb-4">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">03:00PM – 04:30PM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold text-[25px] leading-[25px] text-[#6b15a9]">The Purple Movement</p>
                <p class="mb-3">Setting Kerala to ride the waves of change</p>
              </div>
            </li>
            <!-- <li class="flex flex-wrap marker pb-4">
              <div class="w-full md:w-1/4 text-gray-500 text-sm">03:25PM – 03:40PM</div>
              <div class="w-full md:w-3/4 text-gray-500 text-sm">
                <p class="font-bold">The Purple Manifesto and Pledge</p>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="w-full py-10 bg-[#f4f4f4]">
  <div class="container mx-auto">
    <div class="flex flex-col items-center justify-between">
      <div class="w-full md:w-[60%] lg:w-[57%] flex flex-col items-center justify-between px-5 md-px-0">
      <p class="font-semibold mb-3 text-xl sm:text-[26px] w-full text-center">High Tea and Networking</p>
      <p class="text-base text-center">04:30 PM – 05:00 PM</p>
      </div>
    </div>
  </div>
</div>
<!-- <div class="w-full p-12 bg-slate-50">
  <div class="container mx-auto max-w-screen-xl">
    <div class="carousel w-full">
      <div id="slide01" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE1.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide07" class="btn btn-circle">❮</a>
          <a href="#slide02" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide02" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE2.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide01" class="btn btn-circle">❮</a>
          <a href="#slide03" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide03" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE3.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide02" class="btn btn-circle">❮</a>
          <a href="#slide04" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide04" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE4.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide03" class="btn btn-circle">❮</a>
          <a href="#slide05" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide05" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE5.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide04" class="btn btn-circle">❮</a>
          <a href="#slide06" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide06" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE6.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide05" class="btn btn-circle">❮</a>
          <a href="#slide07" class="btn btn-circle">❯</a>
        </div>
      </div>
      <div id="slide07" class="carousel-item relative w-full">
        <img src="assets/images/dk17/slider/PORT80-TIMELINE7.jpg" class="w-full" />
        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a href="#slide06" class="btn btn-circle">❮</a>
          <a href="#slide01" class="btn btn-circle">❯</a>
        </div>
      </div>
    </div>
  </div>
</div> -->

<dialog id="my_modal_1" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/venkat.jpg" alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Venkatramanan P.R</h2>
        <p class="text-neutral-400">Data Scientist</p>
        <p class="text-neutral-600 mb-2">Thought Works</p>
        <p class="text-slate-600 text-sm leading-6">Venkat is Lead Consultant and Data Scientist at ThoughtWorks. Over
          the last few years, he has helped build the data science capability within ThoughtWorks India, and worked with
          clients across several industries to deliver data science solutions. Before this, he used to work as a
          Physicist, working primarily in the field of phase transitions in Soft Condensed Matter systems.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_2" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/michael.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Michael Gord</h2>
        <p class="text-neutral-400">Founder & CEO</p>
        <p class="text-neutral-600 mb-2">MLG Blockchain Consulting</p>
        <p class="text-slate-600 text-sm leading-6">Michael is a blockchain developer at TD and the founder of Bitcoin
          Canada and the McGill Cryptocurrency Club. While at McGill, Michael organized the Bitcoin Airdrop events where
          he gave hundreds of students their first bitcoin</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_3" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/satish-babu.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Satish Babu</h2>
        <p class="text-neutral-400">Chair, APRALO</p>
        <p class="text-neutral-600 mb-2">ICANN</p>
        <p class="text-slate-600 text-sm leading-6">Programmer, Development Professional and Internet Governance
          Practitioner, associated with ICANN, ISOC, IEEE and InApp. Fellow and former President of Computer Society of
          India. Chair, APRALO, ICANN and Member, 2017 HAC, IEEE.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_4" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/nandini.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Professor Nandini Vaidyanathan</h2>
        <p class="text-neutral-400">Chairman and Managing Director</p>
        <p class="text-neutral-600 mb-2">CARMa Venture Services</p>
        <p class="text-slate-600 text-sm leading-6 mb-2">She’s a traveling teacher who specialises in entrepreneurship,
          in several Ivy League business schools around the world.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">After 20 years in the corporate sector, working in MNC-s
          in all inhabited continents, she returned to India in 2005 and
          began teaching entrepreneurship. Realizing that the only way she could bring real time experience to her
          classroom was if she became an entrepreneur herself, she founded CARMa (Creating Access to Resources &
          Markets; www.carmaconnect.in) with a lofty ambition: to offer professional mentoring to entrepreneurs as a
          risk mitigating strategy. CARMa mentors start-ups, mature enterprises and family businesses. As on date, CARMa
          has mentored over 2000 entrepreneurs. CARMa has also been involved in mentoring women to scale from livelihood
          enterprises to opportunity-based and profitable organizations in Afghanistan, South and East Africa and India.
          Till date over 10,000 women have been mentored to build scalable and profitable enterprises.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          A prolific writer for mainstream newspapers, portals and blogs, her first book Entrepedia: A Step by Step
          Guide to Becoming an Entrepreneur in India, has been a best-seller since its launch in 2011. Its second
          edition, updated and contemporized, came out in 2015 and has become the Bible of the start-up community. Her
          second book, Start up, Stand up, was published in 2016. While Entrepedia was all about how to take an idea
          from your head to the marketplace, Start up, Stand up is about how to grow your business from your first
          paying customer to an evangelical user community.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          A TED speaker and regular jury member of television shows on business channels and entrepreneurship events
          across the world, she was named Business Woman of the Year by Business Goa in 2014.
        </p>
        <p class="text-slate-600 text-sm leading-6">
          Passionate about cooking and entertaining people, her versatility extends to the Carnatic form of music in
          which she is a trained singer. She currently lives in Goa.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_5" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/rama-brahmam.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Rama Brahmam Aleti</h2>
        <p class="text-neutral-400">Co-Founder & UX Strategist</p>
        <p class="text-neutral-600 mb-2">Think Design Collaborative </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">As a Co-founder & Director - Experience Design, at Think Design
          Collaborative, Rama has been instrumental in developing the company into a leading, world-class UX Design and
          Innovation Consultancy. As part of the core team, Rama helps in driving the company's strategy, business and
          mentor its overall growth. He heads a team of over 90 Designers and has implemented 200+ UX projects in
          multiple domains such as - Finance, Education, Healthcare, Telecom, E-Commerce, and Entertainment. The
          companies
          include several Fortune companies, MNCs and startups.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">In addition to leading the practice at Think Design, Rama also
          conducts workshops on Design Thinking, Experience Design & Innovation. Rama is a regular speaker for Product
          Conclave at NASSCOM Events; a warm association that has seen him conducts six such workshops. He has also been
          invited by IIM-A, Indian School of Business (ISB), Unicom and conducted numerous Design workshops within
          India, North America and South America.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          Rama recommends initiating Design through workshop/s by inviting all stakeholders who can participate and
          hence collaborate in the solutioning process. He believes ‘Design Driven Innovation’ is the future and is
          certain that most of the businesses in this connected world will use it as a tool to stay ahead in business
          and innovation.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">
          Rama is a Post Graduate from the prestigious National Institute of Design (NID) after doing his Graduation in
          Applied Arts from Jawaharlal Nehru Technological University (JNTU). An ardent Design background is what
          enables Rama to extend his expertise to Strategic Design, Experience Design and Design Thinking.
        </p>
        <p class="text-slate-600 text-sm leading-6">
          On a personal front, he loves his South Indian delicacies, is an avid movie enthusiast, a great fan of Indian
          films, especially his regional Telugu movies. Even whilst pursuing his geeky inclinations, he loves spending
          time with his family, particularly, playing with his daughter and watching her grow up.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_6" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/abhilash-ashok.jpg"
          alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Abhilash Ashok</h2>
        <p class="text-neutral-400">Senior Lead, UX Development</p>
        <p class="text-neutral-600 mb-2">Valorem </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">An Incorruptible Passionate Microsoft Technology Stack
          Enthusiast with rich 8+ years’ experience, well-versed with Windows 10/UWP, Xamarin, WPF, HoloLens, Windows
          Phone/ Store/RT, Kinect for Windows, Xbox, Unity 3D, and legacy technologies like ASP.NET, Silverlight, ExtJS,
          WinForms, etc. He’s a prominent speaker in Microsoft Technology Community mainly K-MUG.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">He completed graduation in Computer Engineering from Mahatma
          Gandhi University in 2007. He’s working as Technical Team Lead at Identitymine – a UX Strategy expert company,
          working close with Microsoft, where he’s responsible for developing premium apps and services with cutting
          edge technologies. Besides development, he loves mentoring & building enthusiastic team. He finds himself
          lucky enough to work close with MVPs and Microsoft Regional Directors.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">He also has solid experience in airline domain, telecom domain,
          software and services; combined with proven experience in product life cycle, product quality, envisioning
          features, development and implementation. He had received various awards and laurels for his proven
          performance.
          He writes about “Nerds False Positive” in his blog – CameTooFar (http://cametoofar.com/) and tweets at
          https://twitter.com/abhilashca. </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_7" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/sanju-mathew.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Sanju Mathew</h2>
        <p class="text-neutral-400">CEO</p>
        <p class="text-neutral-600 mb-2">Onbyz </p>
        <p class="text-slate-600 text-sm leading-6">Sanju Mathew is an Mtech Electronics graduate (Signal
          Processing and Bionics), Entrepreneur, Intel IoT Innovator and a speaker at National and International
          conferences on Bionics and IoT. He is an Electronics Hardware Engineer, System Architect and UI/UX designer by
          choice with over 7 years of experience in these fields. His work includes a Predictive Maintenance AI for
          Airports (Australia), Water Supply Automation system for star hotels (USA) and Laser Calibration unit for
          Spectroscopy units (USA). His team built a Low Cost Bionic Hand for the disabled that focuses on modularity of
          sensors, custom designed feedback systems, powerful and low footprint microprocessor unit and a software
          architecture that makes use of Marketplace and community driven app development. Projects realized by his team
          was selected twice as top 10 in the world by Intel and was invited to present it at Intel Developer Forum 2015
          and 2016 at San Francisco, USA. His team was awarded the runners-up prize for Mastermind competition by Dr. A
          P J Abdul Kalam and was one of the winners for National Level Intel IoT Hackathon 2015.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_8" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/anivar.jpg" alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Anivar Aravind</h2>
        <p class="text-neutral-400">Founder Executive Director</p>
        <p class="text-neutral-600 mb-2">Indic Project </p>
        <p class="text-slate-600 text-sm leading-6">Anivar A. Aravind is Founder Executive Director of Indic Project, a
          civic-tech non-profit initiative works on language engineering, technology standards and digital rights.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_9" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/rafi.jpg" alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Mohammed Rafi T.F</h2>
        <p class="text-neutral-400">Behavioural Scientist, Life Transformation Specialist and International Master
          Trainer</p>
        <p class="text-neutral-600 mb-2">Neuro Lingusitic Programme </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">A Behavioural Scientist, Life Transformation Specialist and
          International Master Trainer in Neuro Lingusitic Programme with more than 13 years of experience in various
          streams ranging from Information Technology to Education to Retail and Insurance.
        </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">Have heart fully trained more than 100 thousand people ranging
          from CEO’s to Celebrities to Billion Dollar Entrepreneurs. Was instrumental in coaching and mentoring senior
          managers and CEO’s of Corporate, Government, Private Sector and NGO’s to bring out the best in them and
          achieve excellence in their respective fields. A creative professional who applies his heart and soul into any
          assignment that he takes, and transforms the lives of those he comes across in his training programs and one
          to one coaching sessions.</p>
        <p class="text-slate-600 text-sm leading-6 mb-2">He is one of the only two trainers from Asia to be directly
          mentored by NLP Co-Creator Dr.John Grinder. He is also the Peak performance coach for Indian Junior Girls
          Gymnastics team and he is the personal NLP Coach for the National Award Winning Malayalam Actor Jayasurya.
          Some of Rafi’s esteemed clients include Organizations like Coca Cola, Lupin Pharma, Allianz Group, Reliance
          Industries, E&amp;Y;, LIC and many more. Currently he is pursuing research in Behavioural Neuropsychology,
          NLP,
          Micro Expression Patterns and Provocative Coaching.</p>
        <div>
          <h3 class="text-lg font-bold mb-2">Educational Competency: </h3>
          <ul>
            <li class="text-slate-600 text-sm list-disc ml-3">Master in Human Resource Management</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Researcher in Behavioural Neuropsychology Certified
              International NLP Master Trainer.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Certified Peak Performance and Behavioural Trainer.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Certified Fire Walk Trainer.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Sales Mastery Expert.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">Certified Provocative Therapy Practitioner.</li>
            <li class="text-slate-600 text-sm list-disc ml-3"> Integral Eye Movement Therapy Advanced Practitioner.</li>
            <li class="text-slate-600 text-sm list-disc ml-3">1 year Management development program from School of
              Communication and Management Studies</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_10" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/manuyash-chaudhary.jpg"
          alt="" /></div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. Manuyash Chaudhary</h2>
        <p class="text-neutral-400">AI & NLP Developer & Researcher</p>
        <p class="text-neutral-600 mb-2">Accubits </p>
        <p class="text-slate-600 text-sm leading-6">Mr. Manuyash Chaudhary works as AI & NLP Developer & Researcher,
          Accubits Technologies. An MS in Machine Learning & Artificial Intelligence from University College London,
          Manuyash has been instrumental for path-breaking research on Data Science and its implementation during his
          career. He is responsible for developing AI technologies and solving machine learning problems for clients at
          Accubits. He works in Python and R, on platforms like Tensorflow, H2O.ai and tools like SPSS, WEKA and
          Tableau.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_11" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/sivasankar.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
        <p class="text-neutral-400">IT Secretary</p>
        <p class="text-neutral-600 mb-2">Government of Kerala </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">Shri. M Sivasankar is presently the Secretary to Government, IT
          Department since June, 2016. He is also holding the charge of Officer on Special Duty to the Chief Minister of
          Kerala.
        </p>
        <p class="text-slate-600 text-sm leading-6">Sivasankar an Engineering Graduate and a Master of Business
          Administration (MBA) started his career as an officer in the Reserve Bank of India. He was subsequently
          appointed as Deputy Collector to the Government. While in service he was selected to the Indian Administrative
          Service (IAS) in 1995 which is the highest bureaucratic position in administrative service of India.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_12" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/sivasankar.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr. M Sivasankar IAS</h2>
        <p class="text-neutral-400">IT Secretary</p>
        <p class="text-neutral-600 mb-2">Government of Kerala </p>
        <p class="text-slate-600 text-sm leading-6 mb-2">Shri. M Sivasankar is presently the Secretary to Government, IT
          Department since June, 2016. He is also holding the charge of Officer on Special Duty to the Chief Minister of
          Kerala.
        </p>
        <p class="text-slate-600 text-sm leading-6">Sivasankar an Engineering Graduate and a Master of Business
          Administration (MBA) started his career as an officer in the Reserve Bank of India. He was subsequently
          appointed as Deputy Collector to the Government. While in service he was selected to the Indian Administrative
          Service (IAS) in 1995 which is the highest bureaucratic position in administrative service of India.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_13" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/ashraf.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Dr. Asharaf S</h2>
        <p class="text-neutral-400">Associate Professor</p>
        <p class="text-neutral-600 mb-2">IIITMK</p>
        <p class="text-slate-600 text-sm leading-6">Asharaf S is an Associate Professor at Indian Institute of
          Information Technology and Management – Kerala. He is also serving as a visiting faculty in Indian Institute
          of Space Science and Technology, Trivandrum and as a Mentor in Kerala Startup Mission. He received his PhD and
          Master of Engineering degrees in Computer Science from Indian Institute of Science, Bangalore. He graduated in
          Computer Engineering from Cochin University of Science and Technology. After his PhD he has worked with
          America Online (AOL) and IIM Kozhikode. He is a recipient of IBM outstanding PhD student award 2006, IBM
          Shared University Research Grant 2015 and IBM OSCP Grant 2017. He has published three books and more than 30
          research papers in international journals and conferences. His areas of interest include technologies and
          business models related to machine learning, web mining, intelligent internet of things and blockchains.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_14" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/rahul.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr Rahul Alex Panicker</h2>
        <p class="text-neutral-400">Co-founder and President</p>
        <p class="text-neutral-600 mb-2">Embrace Innovations </p>
        <p class="text-slate-600 text-sm leading-6">A technology product leader, Mr. Panicker loves building and leading
          creative teams to actualize magical products. He spends his time with users, working with designers,
          engineers, marketers, and sales folks to create these products, and taking them to market, giving them lots of
          TLC, and having their magic spread. As co-founder and president of Embrace, which has helped over 250,000
          vulnerable babies in the developing world, since 2012, his next mission is to transform the world through AI.
        </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_15" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/aswin.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Mr Aswin P</h2>
        <p class="text-neutral-400">Program Manager</p>
        <p class="text-neutral-600 mb-2">Frost Sullivan's Middle East</p>
        <p class="text-slate-600 text-sm leading-6">Aswin Kumar is Program Manager with the Mobility (Automotive &
          Transportation) Practice for Frost Sullivan's Middle East, North Africa and South Africa region He has over
          eight years of BusIness Research and Strategy Consulting experience, which Include over 50 research and
          consulting projects. His expertise lies in Urban Technology Convergence, Telematics, Business Analysis, Market
          Entry, Geographical Expansion, Strategic Planning, Pricing Strategy, New Product Launch, Business Modelling
          and Planning, and After Market & OE Strategies. </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_16" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/dk17/anoop.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Anoop Ambika</h2>
        <p class="text-neutral-400">Founder</p>
        <p class="text-neutral-600 mb-2">CLAP Research</p>
        <p class="text-slate-600 text-sm leading-6 mb-3">Anoop P Ambika is a serial entrepreneur, organiser and a
          technology enthusiast. He is the co-founder of several technology/ environment startups and currently is Chief
          Executive
          Officer of CLAP Research and Genpro Life Sciences. </p>
        <p class="text-slate-600 text-sm leading-6">CLAP Research brings together a team of Machine Learning,
          Statistics, NLP and Cognitive Neuroscience specialists to enable the transition of enterprise applications
          from deterministic systems to implicit learning systems. </p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_01" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/ajith.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Ajit Balakrishnan</h2>
        <p class="text-neutral-400">Founder</p>
        <p class="text-neutral-600 mb-2">rediff.com</p>
        <p class="text-slate-600 text-sm leading-6">Shri Ajit Balakrishnan, an alumnus of IIM Calcutta, is a pioneering Indian IT entrepreneur. At just 22, he co-founded the advertising firm Rediffusion. In 1995, he founded Rediff.com, which achieved a NASDAQ listing and is recognized as one of India's most successful Internet companies. He led Rediff.com to multiple CIO Choice Awards. An Elite Strategic Business Communicator, Ajit was once named the Chairman Emeritus of the Internet and Mobile Association of India (IAMAI) and has chaired significant committees for both the Ministry of Information Technology and the Ministry of Human Resource Development.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_02" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/thumb/jayasankar-prasad.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Dr Jayasankar Prasad</h2>
        <p class="text-neutral-400">Director, DCSMAT</p>
        <p class="text-slate-600 text-sm leading-6">
          Dr. Jayasankar Prasad C (Dr Jay) is a management professional with extensive experience in organization leadership, policy formulation, project consulting, and implementation. He has managed senior management portfolios in both government and private organizations. He is also the Honorary Professor of Management and Entrepreneurship at the International Centre for Free and Open-Source Software (ICFOSS), as well as a Mentor and curriculum committee member for the Additional Skill Acquisition Program. He currently serves as the Director at DCSMAT Institutions, Kerala. He has noted professional stints in TCS , ICICI Kinfra and Avt McCormick, ICSFOSS, KSITM and Vizhinjam Port, and is recognised much for his work in building the startup Ecosystem in Kerala as the founder CEO of Kerala Startup Mission (KSUM).</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_03" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/pradeep-nair.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Pradeep Nair</h2>
        <p class="text-neutral-400">Founder CTO, Armada</p>
        <p class="text-slate-600 text-sm leading-6">
          Pradeep Nair is the Founding CTO of Armada, a pioneering full-stack edge computing platform. With a distinguished career that includes leadership roles as VP at Microsoft Azure and VP of Engineering at VMware, he's an executive renowned for building market-leading cloud infrastructure solutions and leading multibillion-dollar products spanning multiple geographies. Holding multiple patents in hyperscale computing, infrastructure operations and security, Pradeep brings profound expertise in cloud strategy, large-scale tech innovation, and managing diverse high-performance teams.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_04" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/jyothis.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Jyothis Indirabhai</h2>
        <p class="text-neutral-400">Co-Founder and CEO, Netrasemi</p>
        <p class="text-slate-600 text-sm leading-6">
          With over 25 years experience in microchip design, Jyothis Indirabhai is the Co-Founder and CEO of Netrasemi - a Thiruvananthapuram-based semiconductor startup developing system-on-chips (SoCs) for low-power Edge AI market. Before founding Netrasemi, he worked as a Design Manager and Micro Architect at Intel corporation for their GPU and chipset teams. He also worked at Hitachi, Japan and a few very successful semiconductor startups in California. His expertise include SoC design, hardware acceleration architectures and wireless baseband designs. He has 8 US patent grants and 7 pending applications in the domains of Artificial intelligence and wireless technologies. Jyothis is a CET alumni of 1995 batch in Electronics and communication.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_05" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/pradeep-ps.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Pradeep P. S</h2>
        <p class="text-neutral-400">Founder, Farmers Fresh Zone</p>
        <p class="text-slate-600 text-sm leading-6">
          Pradeep P. S. is the visionary sole founder of Farmers Fresh Zone, where he revolutionized the farm-to-consumer model. He scaled his venture from a garage startup to a 320-employee operation across 6 South Indian cities, achieving a peak revenue of 29 Cr. Pradeep secured ~$1.5Mn in funding, significantly improved operational efficiencies, and led Farmers Fresh Zone to prestigious national awards and selection for the United Nations' inaugural SDG accelerator. His hands-on entrepreneurial journey is a testament to his experience, expertise and relentless drive for growth and success.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_06" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/thumb/sunny.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Sunny Gupta</h2>
        <p class="text-neutral-400">Engineering Leader, Atlassian</p>
        <p class="text-slate-600 text-sm leading-6">
          Sunny Gupta is an accomplished Engineering Manager with Atlassian, one of the leading software companies in the world. His passion for coding started at the young age of 12, and since then, he has spent over a decade in the industry, working across various verticals such as eCommerce, SaaS, Fashion-Tech, Med-Tech, and Media, among others.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_07" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/kailash.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Kailash Nadh</h2>
        <p class="text-neutral-400">CTO, Zerodhan</p>
        <p class="text-slate-600 text-sm leading-6">
          Kailash Nadh is the CTO of Zerodha, India's largest stockbroker, where he built and leads the tech team pioneering innovative financial technology. A lifelong software developer and tinkerer with over 25 years of experience, Kailash also co-founded impactful non-profit organizations including FOSS United, Rainmatter Foundation (climate/ecology), and Indic Digital Archive. Bringing an unconventional approach and a unique philosophical lens, he offers profound insights into tech, innovation, and public good.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_08" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/santosh-babu.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Dr Santosh Babu, IAS</h2>
        <p class="text-neutral-400">Principal Secretary & Managing Director, KSITIL</p>
        <p class="text-slate-600 text-sm leading-6">
          Santhosh Babu is a Medical Doctor turned Indian Administrative Service (IAS) Officer of the 1995 batch, of the Tamil Nadu cadre. He is an alumnus of the Government Medical College, Trivandrum. He is also a Chevening Gurukul Scholar from the London School of Economics and Political Science and an LKY Fellow and MPM Degree holder from the National University of Singapore and the Harvard Kennedy School of Government</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_09" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/suresh.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Dr. Suresh K</h2>
        <p class="text-neutral-400">Principal,College of Engineering Trivandrum</p>
        <p class="text-slate-600 text-sm leading-6">
          Santhosh Babu is a Medical Doctor turned Indian Administrative Service (IAS) Officer of the 1995 batch, of the Tamil Nadu cadre. He is an alumnus of the Government Medical College, Trivandrum. He is also a Chevening Gurukul Scholar from the London School of Economics and Political Science and an LKY Fellow and MPM Degree holder from the National University of Singapore and the Harvard Kennedy School of Government</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_010" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/rajashree.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Dr. Rajasree M.S</h2>
        <p class="text-neutral-400">Chief Executive Officer, TrEST Research Park.</p>
        <p class="text-slate-600 text-sm leading-6">
          Dr Rajasree is Professor in Computer Science and Engineering and has ser-ved in government engineering colleges under the State Technical Educ-ation Department for the past 24 years as Lecturer, Assistant Professor, Prof-essor and Principal. Befo-re joining the college, she was the Director of Indi-an Institute of Informat-ion Technology Manage-ment Kerala –IIITMK.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_011" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/thumb/Rajeev-J-Sebastian.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Rajeev J Sebastian</h2>
        <p class="text-neutral-400">CEO, Alokin Software</p>
        <p class="text-slate-600 text-sm leading-6">
          Rajeev has associated with many successful national and international projects during his 16 years in the industry, including One Rank One Pension, Kerala State Legislative Assembly Knowledge Base, DC Books, Rachana Malayalam Operating System, American Honda Bikes, Toyota Racing Development, AOL Movies and Music, etc. He is a follower and contributor to various open source projects such as KDE, Kubuntu, Pardus Linux, SCIM, Mootools, etc. He also played a leading role in the Malayalam Unicode encoding standards, and development of UIs and fonts for Malayalam. Currently the CEO of Alokin Software, he leads a team of Python and OOP developers and is deeply interested in Software Engineering, OOP, AI, philosophy and films.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_012" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/vimal-govind.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">Vimal Govind M K</h2>
        <p class="text-neutral-400">Co-founder and Director, Genrobotic Innovations </p>
        <p class="text-slate-600 text-sm leading-6">
          Vimal Govind M. K is a notable robotic engineer and product architect from Kerala. As the Co-Founder and Managing Director of Genrobotics Innovations, Vimal leads the in-house technical team while actively involved in the administration of marketing and business strategies. The flagship product of his company, ‘Bandicoot’ has primarily focused on the empowerment of sanitation workers and their lives. With remarkable credentials in the field of robotics, he has established himself as a prominent figure in the industry.</p>
      </div>
    </div>
  </div>
</dialog>
<dialog id="my_modal_013" class="modal">
  <div class="modal-box w-11/12 max-w-5xl">
    <div class="modal-action mt-2">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-neutral hover:btn-primary hover:text-slate-50 absolute right-4 top-4">X</button>
      </form>
    </div>
    <div class="w-full popup-wrap">
      <div class="float-left pr-3 pb-3 dk-image"><img class="w-full" src="assets/images/beyond/speaker/levin.jpg" alt="" />
      </div>
      <div>
        <h2 class="text-xl font-bold mb-0">G LEVIN </h2>
        <p class="text-neutral-400">Chief Executive Officer - Kerala Spacepark</p>
        <p class="text-slate-600 text-sm leading-6">
          38 years of illustrious career with Vikram Sarabhai Space Centre(VSSC), Indian Space Research Organization(ISRO). Retired as the Deputy Director, Solid Propulsion and Research Entity (SPRE) in May, 2020. An expert in solid propulsion systems, played a key role in design, development and qualification of solid motors for PSLV,GSLV,MKIII,SSLV etc. An acknowledged expert in Non-Destructive Testing, composites, ablatives, propellant etc
Took up the responsibility of setup the Kerala Spacepark, as the founder Project Director, in August 2021. Incorporated Kerala Spacepark(KSPACE) as an independent organization under the Electronics & IT Department of the Government of Kerala. KSPACE is responsible to promote industries in the Space technology sector and the allied domains in Defence and Aerospace</p>
      </div>
    </div>
  </div>
</dialog>